import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';
import { isScanningAtom } from '../atoms/session-atoms';
export const useOnScanFinished = callback => {
  const isScanning = useAtomValue(isScanningAtom);
  const prev = useRef(isScanning);
  useEffect(() => {
    if (prev.current && !isScanning) {
      callback();
    }
    prev.current = isScanning;
  }, [isScanning, callback]);
};
//# sourceMappingURL=use-on-scan-finished.js.map